// src/components/NotFoundPage.js

import React, { useEffect } from "react";
import { Container, Typography, Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import SearchOffIcon from "@mui/icons-material/SearchOff";

const NotFoundPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const message =
    location.state?.message || "La dirección (URL) que buscas no existe.";

  useEffect(() => {
    const checkSubdomain = async () => {
      const hostname = window.location.hostname;
      const subdominio = hostname.split(".")[0];

      // Si no hay subdominio, no continuar
      if (!subdominio) return;

      try {
        const response = await fetch(
          `/api/nutriologo/subdomain/info?subdominio=${subdominio}`
        );
        if (response.ok) {
          const result = await response.json();
          // Si se obtiene información válida del nutrólogo, redireccionar a /registro
          if (result && result.nutriologoInfo) {
            navigate("/", { replace: true });
          }
        }
      } catch (error) {
        console.error("Error al validar el subdominio:", error);
      }
    };

    checkSubdomain();
  }, [navigate]);

  return (
    <Box
      sx={{
        background: "radial-gradient(circle at top left, #e0f7fa, #f5f7fa)",
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 0,
      }}
    >
      <Container
        maxWidth="md"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          p: 4,
        }}
      >
        <Box sx={{ mb: 4 }}>
          <SearchOffIcon
            sx={{
              fontSize: { xs: "6rem", md: "10rem" },
              color: "#1976d2",
              mb: 3,
              boxShadow: "0px 0px 20px rgba(25, 118, 210, 0.5)",
              borderRadius: "50%",
              p: 2,
              backgroundColor: "rgba(25, 118, 210, 0.1)",
            }}
          />
        </Box>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ mb: 2, color: "#424242", fontWeight: 600 }}
        >
          ¡Ups! Página no encontrada
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#616161" }}>
          {message}
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#616161" }}>
          Te recomendamos que verifiques la dirección web nuevamente.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#616161" }}>
          Si persiste el problema, consulta con tu nutricionista para que te
          brinde la dirección correcta.
        </Typography>
        <Typography sx={{ mt: 4, color: "#9e9e9e" }}>
          <p>
            <strong>&copy; 2022 Desarrollo Azul - </strong>
            Desarrollo de Software
          </p>
        </Typography>
      </Container>
    </Box>
  );
};

export default NotFoundPage;
